<template>
	<el-space fill wrap :fill-ratio="49" size="large" class="w-100" alignment="stretch">
		<wa-sessions v-if="isPengelolaWa" />
		<mesin-presensi v-if="isPetugasPresensi" />
		<user-presensi v-if="isPetugasPresensi" />
		<izin-presensi v-if="isPetugasPresensi || isStaf" />
		<data-presensi v-if="isPetugasPresensi || isStaf" />
	</el-space>
</template>

<script>
import DataPresensi from "@/components/DataPresensi.vue";
import IzinPresensi from "@/components/IzinPresensi.vue";
import MesinPresensi from "@/components/MesinPresensi.vue";
import UserPresensi from "@/components/UserPresensi.vue";
import WaSessions from "@/components/WaSessions.vue";

export default {
	name: "HomeView",
	data() {
		return {};
	},
	components: {
		WaSessions,
		MesinPresensi,
		UserPresensi,
		IzinPresensi,
		DataPresensi,
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		isPengelolaUser() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "presensi"].includes(r.role));
		},
		isPengelolaWa() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "wa"].includes(r.role));
		},
		isPetugasPresensi() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "presensi"].includes(r.role));
		},
		isStaf() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "staf"].includes(r.role));
		},
	},
	watch: {},
	mounted() {},
	beforeUnmount() {},
	methods: {},
};
</script>
